export type CalendarStatus = 'going' | 'interested'

export interface CalendarInclude {
  myEvents?: CalendarStatus[]
  friendEvents?: CalendarStatus[]
  groups?: Record<string, boolean>
  groupDefault?: boolean
  forceAllDay?: boolean
}

export const DEFAULT_INCLUDE: CalendarInclude = {
  myEvents: ['going', 'interested'],
  friendEvents: [],
  groups: {},
  groupDefault: false,
}
